import { IconInfoCircleOutline } from '@iwoca/icons';
import { GetDrawDownRepaymentScheduleCreditFacilityResponse } from '@iwoca/lapi-client/edge';
import { AlertBox, Text } from '@iwoca/orion';
import { FormattedMessage } from 'react-intl';

import {
    AmortisationPhaseTable,
    AmotisationPhaseHeader
} from './AmortisationPhase';
import { PostRepaymentFreePeriodExplainer } from './PostRepaymentFreePeriodExplainer';
import {
    RepaymentFreePeriodHeader,
    RepaymentFreePeriodTable
} from './RepaymentFreePeriod';

export const PaymentPlanSchedule = ({
    repaymentSchedule,
    isInRepaymentFreePeriod
}: {
    repaymentSchedule: GetDrawDownRepaymentScheduleCreditFacilityResponse['data'];
    isInRepaymentFreePeriod?: boolean;
}) => {
    const schedule = repaymentSchedule.schedule;
    const summary = repaymentSchedule.summary;

    const interestOnlySchedule = schedule.filter(
        (repayment) => repayment.principal === 0
    );

    const principalRepaymentsSchedule = schedule.filter(
        (repayment) => repayment.principal > 0
    );

    return (
        <div className="space-y-xl" data-testid="rcf-repayment-schedule">
            <div>
                <RepaymentFreePeriodHeader
                    isInRepaymentFreePeriod={isInRepaymentFreePeriod}
                />
                <RepaymentFreePeriodTable schedule={interestOnlySchedule} />
            </div>
            <PostRepaymentFreePeriodExplainer />
            <div>
                <AmotisationPhaseHeader />
                <AmortisationPhaseTable
                    schedule={principalRepaymentsSchedule}
                    summary={summary}
                />
            </div>
            <AlertBox variant="connect" className="flex flex-row gap-xs">
                <IconInfoCircleOutline className="size-[20px] shrink-0" />
                <Text className="text-s">
                    <FormattedMessage
                        id="_.rcf_approved_view.repayment_schedule_alert_box"
                        defaultMessage="<span>As a reminder:</span> You can make repayments at any time for free and save on interest costs."
                        values={{
                            span: (chunks) => (
                                <span className="font-bold">{chunks}</span>
                            )
                        }}
                    />
                </Text>
            </AlertBox>
        </div>
    );
};
